module.exports = __webpack_public_path__ + "images/home9.webp";